
// Define important dates in a central location

// Set launch date to May 16, 2025 (16 days after election date)
export const CAYMAN_LAUNCH_DATE = new Date("2023-05-16T18:00:00");

// Election date (April 30, 2025)
export const CAYMAN_ELECTION_DATE = new Date("2023-04-30T00:00:00");

// Check if the launch date has passed - Modified to always return true
export const hasLaunchDatePassed = (): boolean => {
  return true; // Always return true to disable waitlist features
};

// Calculate days remaining until launch
export const daysUntilLaunch = (): number => {
  const now = new Date();
  const differenceInTime = CAYMAN_LAUNCH_DATE.getTime() - now.getTime();
  return Math.max(0, Math.ceil(differenceInTime / (1000 * 3600 * 24)));
};
